//@flow
export const CONFIRMATION_MESSAGE = `
  All traces of this loop and it's slides will be gone and any kiosks
  depending on this loop will need to be updated in order to have a
  functioning intro.`



// WEBPACK FOOTER //
// ./src/AttractLoops/constants.js